import axiosIns from '@/libs/axios';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchWeeks(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get('reports/fetchWeeks', { params: queryParams })
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    dashboardSummary(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('reports/dashboard-summary', data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    taskReport(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('reports/task-report', data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    userReport(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('reports/user-report', data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    downloadPDF(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('reports/download-pdf', data, { responseType: 'blob' })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    downloadPDF2(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('reports/download-pdf2', data, { responseType: 'blob' })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    downloadPDF3(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('reports/download-pdf3', data, { responseType: 'blob' })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    taskDataExport(ctx,data) {
      return new Promise((resolve, reject) => {
        axiosIns
          //.get("user", { params: queryParams })
          .post('reports/taskDataExport',data ,{ responseType: 'blob' })
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    userDataExport(ctx,data) {
      return new Promise((resolve, reject) => {
        axiosIns
          //.get("user", { params: queryParams })
          .post('reports/userDataExport',data ,{ responseType: 'blob' })
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },
    // New Excel export actions aligned with userDataExport pattern
    exportCompanyBenchmark(ctx, data) {
      // Expect data: { eventId, archive, startDate, endDate, school }
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`exportCompanyBenchmark/${data.eventId}` , data, { responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },
    exportCtResultsBreakdown(ctx, data) {
      // Expect data: { eventId, archive, startDate, endDate, school, group, teacher }
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`exportCtResultsBreakdown/${data.eventId}` , data, { responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },

    exportCtResultsTests(ctx, data) {
      // Expect data: { eventId, archive, filterDate: { startDate, endDate }, teacher }
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`exportCtResultsTests/${data.eventId}`, data, { responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },
    exportObserverResultsBreakdown(ctx, data) {
      // Expect data: { eventId, archive, startDate, endDate, school }
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`exportObserverResultsBreakdown/${data.eventId}` , data, { responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },

    exportObserverResultsTests(ctx, data) {
      // Expect data: { eventId, archive, filterDate: { startDate, endDate } }
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`exportObserverResultsTests/${data.eventId}`, data, { responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    },
    taskReportDataExport(ctx,data) {
      return new Promise((resolve, reject) => {
        axiosIns
          //.get("user", { params: queryParams })
          .post('reports/taskReportDataExport',data ,{ responseType: 'blob' })
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },



        getReviewStandardDeviation(ctx, filter) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`getCompanyBenchmarkAnalysis/${filter.event.id}`, filter)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },


    getCTResultsEventId(ctx, filter) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`getCTResultsBreakdown/${filter.event.id}`, filter)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getCTResultsGruopId(ctx, filter) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`getCTResultsBreakdown/${filter.event.id}`, filter)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getCTResultsByTeacher(ctx, filter) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`getCTResultsBreakdown/${filter.event.id}`, filter)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getReviewsWithIdObserver(ctx, filter) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`getResultsWithObserverEventId/${filter.event.id}`, filter)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

        getReviewsObsWithId(ctx, filter) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`getObserverResultsBreakdown/${filter.event.id}`, filter)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    // Quality Review Stats uses a dedicated endpoint: anyone with view_review_report
    // sees stats for every review (unlike the list), and the payload is trimmed to
    // just { id, event, summary }, which is all the stats screens consume.
    getAllReviewResults(ctx, filterDate) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("listResultStats", filterDate)
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },
      getLastEventItem(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("getLastResult", {})
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },






    
    
    

  },
};
